import React from 'react'
import { IMaskInput } from 'react-imask'

import PropTypes from 'prop-types'

export const PhoneInputMask = React.forwardRef(
  function PhoneInputMask(props, ref) {
    const { onChange, ...other } = props
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={value => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    )
  }
)

PhoneInputMask.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}
